export const ErrorTypes = Object.freeze({
    ApiError: 'api_error',
    Notification: 'notification',
    FrontendValidation: 'frontend_validation',
});

export const ErrorCategory = Object.freeze({
    Error: 'error',
    UserError: 'user error',
    Timeout: 'timeout',
});

export const TechnicalComponent = Object.freeze({
    Favourites: 'Favourites',
    Cart: 'Cart',
    OrderCapture: 'Order Capture',
    OnlinePayment: 'Online Payment',
    ACI: 'ACI',
    GoogleMaps: 'GoogleMaps',
    TaskRabbit: 'TaskRabbit',
    Profile: 'Profile',
    IBES: 'IBES',
    RIX: 'RIX',
});
